<div class="wrapper">
	<div class="text-container" role="region" aria-label="Text container">
		<ion-row class="ion-align-items-start">
			<ion-col>
				<h3>{{ 'order.note.header' | translate }}</h3>
			</ion-col>
			<ion-icon
				(click)="dismiss()"
				size="large"
				name="close"
				src="../../../assets/icon/cross.svg"
				role="img"
				aria-label="Close"
			></ion-icon>
		</ion-row>
		<ion-row role="region" aria-label="Content section">
			<ion-col>
				<ion-textarea
					[(ngModel)]="inputNote"
					rows="4"
					cols="10"
					placeholder="{{ 'order.note.placeholder' | translate }}"
				></ion-textarea>
			</ion-col>
		</ion-row>
	</div>
	<ion-row>
		<ion-col class="button-block">
			<ion-button class="button button-block_dismiss" (click)="dismiss()">
				{{ 'order.note.cancel' | translate }}
			</ion-button>
			<ion-button class="button button-block_add" (click)="addNote()">
				{{ 'order.note.ok' | translate }}
			</ion-button>
		</ion-col>
	</ion-row>
</div>
